import { Component } from '@angular/core';
import { TeamManagerService } from './../../services/teammanager.service';
import { LoaddingService } from './../../providers/loadding.service';
import { PageDefault } from './../../pages/PageDefault';
import { SendMessagePage } from './../../pages/send-message/send-message';
import { ModalController, NavController } from 'ionic-angular';
import { TeamManagerSearch } from './teammanagersearch';
import { ChangeBonus } from './changebonus';
import { Deposit } from './deposit';
import { UserLimits } from './userLimits';
import { StorageService } from '../../providers/storage.service';
import { UserModel } from '../../models/user.model';

/*
    团队管理
    TQQ 2017-01-03
*/
@Component({
    selector: "team-manager",
    templateUrl: "teammanager.html",
    providers: [TeamManagerService]
})
export class TeamManagerList {
    constructor(
        private teammanager: TeamManagerService,
        private loadding: LoaddingService,
        private modalCtrl: ModalController,
        public navCtrl: NavController,
        private storage: StorageService
    ) { }

    modelList = [];
    isHave = true;
    paras = {
        SubUserName: '',
        ParentUserName: '',
        PageIndex: 1,
        PageSize: PageDefault.PageSize()
    };
    hasmore = false;
    excludeTracks = [];
    isbtn = false;//是否显示上一级按钮
    pagecounts = 0;
    currscroll;
    information: Object;
    load;
    isRecharge = false;
    userinfo=this.storage.read<UserModel>('User');
    ionViewDidLoad() {
        this.load = this.loadding.showLoding();
        this.getSubUsers().then(s => {
            this.loadding.closeLoading(this.load);
        });
        //判断当前登录用户是否已加入转账白名单
        this.teammanager.canTransfer().then(s => {
            if (s) {
                this.isRecharge = s.Result;
            }
        });
        console.log(this.userinfo)
    }

    //下拉重新加载
    //TQQ 2017-01-03
    doRefresh(refresher) {
        this.paras.PageIndex = 1;
        this.getSubUsers().then(s => {
            refresher.complete();
        });
    }

    //上拉获取下一页信息
    //TQQ 2017-01-03
    doInfinite(infiniteScroll) {
        this.currscroll = infiniteScroll;
        this.paras.PageIndex++;
        this.getSubUsers().then(s => {
            infiniteScroll.complete();
        });
    }

    //查询条件
    //TQQ 2017-01-03
    presentFilter() {
        let modal = this.modalCtrl.create(TeamManagerSearch, this.excludeTracks);
        modal.present();
        modal.onDidDismiss((data: any[]) => {
            if (data) {
                this.excludeTracks = data;
                this.paras.SubUserName = this.excludeTracks["subUserName"];
                this.paras.ParentUserName = '';
                this.paras.PageIndex = 1;
                this.isbtn = true;
                this.getSubUsers();
            }
        });

    }

    //用户名点击事件
    //TQQ 2017-01-05
    usernameClick(name) {
        this.paras.PageIndex = 1;
        this.paras.ParentUserName = name;
        this.paras.SubUserName = '';
        this.isbtn = true;
        this.getSubUsers();
    }

    //返回上一级的单击事件
    upClick() {
        this.paras.PageIndex = 1;
        this.paras.SubUserName = "";
        this.paras.ParentUserName = (this.paras.ParentUserName === this.userinfo.UserName ? '' : this.paras.ParentUserName);
        this.getSubUsers();
    }

    //获取团队管理
    //TQQ 2017-01-03
    getSubUsers() {
        return this.teammanager.getSubUsers(this.paras).then(s => {
            var obj = s.Obj.split("/");
            var obj2 = obj.slice(1,2).toString();
            this.pagecounts = s.PageCount;
            if (this.paras.PageIndex == 1) {
                this.modelList = [];
                this.modelList = s.List;
                if (s.List.length < s.PageCount) {
                    this.hasmore = true;
                } else {
                    this.hasmore = false;
                }
            } else {
                this.modelList = this.modelList.concat(s.List);
                if (this.modelList.length < s.PageCount) {
                    this.hasmore = true;
                }
                else {
                    this.paras.PageIndex = 1;
                    this.hasmore = false;
                }
            }
            if (this.modelList == null || this.modelList.length < 1) {
                this.isHave = false;
            } else {
                this.isHave = true;
            }
            this.paras.ParentUserName = obj2;
            if (!s.Obj) {
                this.isbtn = false;
            }
        }).catch(c => {
            this.loadding.closeLoading(this.load);
        });
    }

    //返点点击事件
    //chen 2017-01-09
    changeBonus(obj) {
        let modal = this.modalCtrl.create(ChangeBonus, {
            information: obj
        });
        modal.present();
        modal.onDidDismiss(() => {
            this.getSubUsers();
        });
    }

    //配额点击事件
    //chen 2017-01-09
    changeDistribute(obj) {
        let modal = this.modalCtrl.create(UserLimits, {
            information: obj
        });
        modal.present();
    }

    //充值点击事件
    //chen 2017-01-09
    deposit(obj) {
        let modal = this.modalCtrl.create(Deposit, {
            toUserName: obj.UserName
        });
        modal.present();
        modal.onDidDismiss((data) => {
            let user = this.modelList.find(s => s.UserName == data['toUserName']);
            user.UserMoney += parseFloat(data['amount']);
        });
    }

    //发消息
    //chen 2017-01-10
    news() {
        this.navCtrl.push(SendMessagePage);
    }

}





// WEBPACK FOOTER //
// ./src/pages/teammanager/teammanager.ts